import React from "react";
import DebitListForBilling from "@icoach/batchPayment/component/DebitListForBilling";
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";

/** =========================================================
 * 📌 租櫃扣款結果列表
 *  =========================================================
 */
const RentCabinetBatchPaymentBatchDebitHistory = () => {
	const { batchPaymentLists } = useBatchPaymentContext();

	return <DebitListForBilling list={batchPaymentLists?.billings} />;
};

export default RentCabinetBatchPaymentBatchDebitHistory;
